function serialize(formData) {
    var object = {};
    var data = formData.entries();
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var input = data_1[_i];
        var key = input[0], value = input[1];
        if (!Reflect.has(object, key)) {
            object[key] = value;
            return;
        }
        if (!Array.isArray(object[key])) {
            object[key] = [object[key]];
        }
        object[key].push(value);
    }
    return object;
}

export { serialize };
